import * as React from "react";
import {
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  BarChart,
  Legend,
  Cell,
  LabelList,
} from "recharts";

const BarChartComp = ({ 
  bar1Key, 
  barChartData, 
  label, 
  layout = "vertical", 
  peerLabel,
  barWidth = 50
}) => {
  const colors = ["#025DC7", "#F1646C"];

  // ✅ Format labels only for legend, not Y-axis
  const formattedData = barChartData.map((item) => {
    if (item.name === "Avg" || item.name.includes("People")) {
      return { ...item, displayName: peerLabel || "Peers (avg)" };
    }
    return { ...item, displayName: item.name };
  });

  // Calculate proper margins based on bar width
  const isThinBars = barWidth <= 35;
  const leftMargin = isThinBars ? 30 : 10;
  const rightMargin = isThinBars ? 50 : 40;

  return (
    <div style={{ 
      width: "100%", 
      height: "250px", 
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 10px"
    }}>
      <div style={{
        width: "100%",
        maxWidth: isThinBars ? "350px" : "500px",
        height: "100%"
      }}>
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={formattedData}
          layout={layout}
          margin={{ top: 20, right: rightMargin, left: leftMargin, bottom: 40 }}
          barCategoryGap="20%"
        >
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
            domain={[0, (dataMax) => Math.ceil(dataMax)]}
          />
          <YAxis
            type="category"
            dataKey="displayName"
            axisLine={false}
            tickLine={false}
            tick={false}
            width={isThinBars ? 20 : 0}
          />
          <Legend
            payload={[
              { value: "You", type: "square", color: "#025DC7", id: "1" },
              { value: peerLabel || "People your age, on average", type: "square", color: "#F1646C", id: "2" },
            ]}
            wrapperStyle={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
            verticalAlign="bottom"
            align="center"
          />
          <Bar 
            dataKey={bar1Key} 
            radius={[4, 4, 0, 0]} 
            minPointSize={3} 
            maxBarSize={isThinBars ? 20 : 50}
            barGap="5%"
          >
            {formattedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
            <LabelList
              dataKey="value"
              position="right"
              fill="#333"
              style={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
              offset={10}
            />
          </Bar>
        </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartComp;
